// extracted by css-extract-rspack-plugin
export default {"IconButton":"TableOfContents-module__IconButton__jrlNM"};